
export default class ClienteDesenvolvimentoViewModel{
    constructor () {
        this.cnpj = undefined;
        this.checkboxExt = false;     
        this.razaoSocial = undefined;
        this.nomeFantasia = undefined;
        this.NumeroSuframa = undefined;
        this.CidadeSelecionada = undefined;
        this.ClienteTipoId = undefined;
        this.EstadoSelecionado = undefined;
        this.EmpresaSelecionada = undefined;
        this.PerfilMaterialSelecionado = undefined;
        this.PotencialSelecionado = undefined;
        this.RepresentanteId = undefined;
        this.icms = false;
        this.pis = false;
        this.ipi = false;
        this.cep = undefined;
        this.cidadenome=undefined;
        this.Arquivos = undefined;
        this.telefone = undefined;
    }
}